/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useState } from "react";
import { IUserSubprofilesStateModel } from "@nf/common";
import styles from "./HeaderUserInfoMobile.module.scss";
import dynamic from "next/dynamic";

const Portal = dynamic<any>(
  () => import("components/Portal").then((mod) => mod.Portal),
  { ssr: false }
);

const SubprofileSelect = dynamic<any>(
  () =>
    import("components/Subprofiles/SubprofileSelect").then(
      (mod) => mod.SubprofileSelect
    ),
  { ssr: false }
);

export interface IHeaderUserInfoMobileProps {
  isLoggedIn: boolean;
  subprofilesState?: IUserSubprofilesStateModel;
}

export const HeaderUserInfoMobile = ({
  isLoggedIn,
  subprofilesState,
}: IHeaderUserInfoMobileProps) => {
  const [modal, setModal] = useState(false);
  const currentSubprofile = subprofilesState?.currentSubprofile;

  const firstLetter = currentSubprofile?.FirstLetter;

  if (!isLoggedIn) return null;

  return (
    <>
      {currentSubprofile && (
        <div className={styles.profileWrapper}>
          <div className={styles.profileHeader} onClick={() => setModal(true)}>
            <div
              className={styles.avatar}
              style={{
                backgroundColor: currentSubprofile.Color,
              }}
            ></div>
            <div className={styles.username}>{firstLetter}</div>
          </div>
        </div>
      )}
      {modal && (
        <Portal>
          <SubprofileSelect
            subprofilesState={subprofilesState}
            setModalVisibility={() => setModal(false)}
          />
        </Portal>
      )}
    </>
  );
};
